import React from 'react';
import {
  FDBox,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import TimelineItemPicker from 'Components/ComponentLibrary/Organisms/Timeline/TimelineItemPicker';

export default function TimelineMonthGroup({
  monthGroupResource, timelineCardComponent, isFirstItem, isLastItem,
}) {
  const timelineItems = monthGroupResource.attr('timelineItems')?.resources().list() || [];
  const timelineItemsLength = monthGroupResource.attr('timelineItems')?.resources().length() || 0;

  return (
    <FDBox>
      {
        timelineItems.map((item, itemIdx) => {
          return (<TimelineItemPicker
            itemResource={item}
            month={itemIdx === 0 ? monthGroupResource.attr('month') : ''}
            timelineCardComponent={timelineCardComponent}
            isFirstItem={isFirstItem}
            isLastItem={isLastItem && itemIdx === timelineItemsLength - 1}
            key={`${monthGroupResource.attr('month')}-${item.id()}`}
          />);
        })
      }
    </FDBox>
  );
}

TimelineMonthGroup.defaultProps = {
  isFirstItem: false,
  isLastItem: false,
};

TimelineMonthGroup.propTypes = {
  monthGroupResource: PropTypes.object.isRequired,
  timelineCardComponent: PropTypes.element.isRequired,
  isFirstItem: PropTypes.bool,
  isLastItem: PropTypes.bool,
};
